$(document).on("about-us:section:performance-highlights", function () {
    if ($("#section-performance-highlights").length > 0) {
        initPerformanceHighlights();
    }
});

function initPerformanceHighlights() {
    let swiper = new Swiper('.swiper-performance-highlights', {
        slidesPerView: 3,
        spaceBetween: 40,
        speed: 800,
        parallax: true,
        autoplay: {
            delay: 2000,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
        },
    });

    // media query for min-width: 992px
    if (window.matchMedia("(min-width: 992px)").matches) {
        let tl = gsap.timeline();

        // .how-it-work-item:first-child and .how-it-work-item:last-child animation
        tl.fromTo(".performance-highlight-item.first", {
            x: 200,
            opacity: 0,
            duration: 0,
        }, {
            x: 0,
            opacity: 1,
            duration: 2,
            scrollTrigger: {
                trigger: ".performance-highlight-item.first",
                start: "top 80%",
                end: "bottom 80%",
                toggleActions: 'play none none reverse',
                scrub: true,
            },
        });

        tl.fromTo(".performance-highlight-item.middle", {
            x: 0,
            opacity: 0,
            duration: 0,
        }, {
            x: 0,
            opacity: 1,
            duration: 2,
            scrollTrigger: {
                trigger: ".performance-highlight-item.middle",
                start: "top 80%",
                end: "bottom 80%",
                toggleActions: 'play none none reverse',
                scrub: true,
            },
        });

        tl.fromTo(".performance-highlight-item.last", {
            x: -200,
            opacity: 0,
            duration: 0,
        }, {
            x: 0,
            opacity: 1,
            duration: 2,
            scrollTrigger: {
                trigger: ".performance-highlight-item.last",
                start: "top 80%",
                end: "bottom 80%",
                toggleActions: 'play none none reverse',
                scrub: true,
            },
        });
    }

}

$(document).on("about-us:section:how-it-works", function () {
    if ($("#section-how-it-works").length > 0) {
        ScrollTrigger.refresh();
        initHowItWorks();
    }
});

function initHowItWorks() {
    let swiper = new Swiper(".swiper-how-it-works", {
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 800,
        parallax: true,
        autoplay: {
            delay: 2000,
        },
        // next and prev button
        navigation: {
            nextEl: '.mil-shared-next',
            prevEl: '.mil-shared-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 4,
                spaceBetween: 40,
            },
        },
    });

    // .line-wrapper
    let tl = gsap.timeline();

    tl.fromTo(".line-wrapper", {
        clipPath: "rect(0 0% 100% 0)",
        transition: "all ease 1s"
    }, {
        clipPath: "rect(0 100% 100% 0)",
        duration: 0.4,
        scrollTrigger: {
            trigger: ".line-wrapper",
            toggleActions: 'play none none reverse',
        },
    });
}

// #section-banner
$(document).on("about-us:section:banner", function () {
    if ($("#section-banner").length > 0) {
        initBanner();
    }
});

function initBanner() {
    let tl = gsap.timeline();
    // #section-banner left to right with scroll trigger
    tl.to("#section-banner", {
        scrollTrigger: {
            trigger: "#section-banner",
            start: "top center",
            end: "bottom top",
            // toggleActions: 'play none none none',
            onEnter: toggleFunc,
        },
    });

    function toggleFunc() {
        $(".section-banner").addClass("animation");
    }
}
